module.exports = __webpack_public_path__ + "img/textos-escritorio.34924f60.png";